export default {
   apiKey: "AIzaSyD-itLZdoaD89hwpgNIFSbFEBopq-vKyK0",
   authDomain: "convodo-d90f0.firebaseapp.com",
   databaseURL: "https://convodo-d90f0.firebaseio.com",
   projectId: "convodo-d90f0",
   storageBucket: "convodo-d90f0.appspot.com",
   messagingSenderId: "315748344058"
};
